
import {
  BlogPostClient,
  TextContentsClient,
  LandingPagesTeasersClient,
  PlayersClient,
  TeamsClient,
  TeamMembersClient, UsersClient
} from './api.clients'
import authService from '@/auth/authService'

const apiHost = 'https://api.kinder-fussball-karlsruhe.de'

const fetchWrapper: { fetch: typeof window.fetch } = {
    async fetch (request, init?): Promise<Response> {
        const token = await authService.getToken()

        return window.fetch(request, {
            ...init,
            headers: {
                ...init?.headers,
                Authorization: `Bearer ${token}`
            }
        })
    }
}

// export const statusClient = new StatusClient(apiHost, fetchWrapper);

export const landingPagesTeasersClient = new LandingPagesTeasersClient(apiHost)
export const blogPostsClient = new BlogPostClient(apiHost)
export const textContentsClient = new TextContentsClient(apiHost)
export const playersClient = new PlayersClient(apiHost, fetchWrapper)
export const teamsClient = new TeamsClient(apiHost, fetchWrapper)
export const teamMembersClient = new TeamMembersClient(apiHost, fetchWrapper)
export const userClient = new UsersClient(apiHost, fetchWrapper)
